import React from 'react';
import { ClassValue } from 'classnames/types';
import Span from '../../Element/Span/Span';
import Typography from '../../Typography/Typography';
import styles from './CardTag.module.scss';
import { SupportedTagColor } from '../../Tag/Tag';

type CardTagProps = {
  /** Card tag text */
  children: string;
  /** Card tag text */
  color?: SupportedTagColor;
  /** Hide, but preserve dimensions */
  hidden?: boolean;
  className?: string;
};

const CardTag: React.FunctionComponent<CardTagProps> = ({
  color = 'orange400',
  children,
  hidden,
  className,
}) => {
  const classNames: ClassValue = [
    styles.cardTag,
    className,
    {
      [styles.cardTag__hidden]: hidden,
    },
  ];

  return (
    <Span
      className={classNames}
      borderRadius={{ size: 'sm', top: false }}
      backgroundColor={color}
      padding={{ vertical: 'xxxs', horizontal: 'xs' }}
      forceWrap
    >
      <Typography
        font="teliasans"
        className={styles.cardTag_text}
        uppercase
        fontWeight="medium"
        color={color === 'orange400' ? 'orange800' : 'white'}
        block
      >
        {children}
      </Typography>
    </Span>
  );
};

export default CardTag;
